import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onDeleteCustomerRes } from "./helper";

export const deleteCustomer = async (id: number) =>
  axios.delete(Routes.DELETE_CUSTOMER + "/" + id);

export const useDeleteCustomer = () =>
  useMutation({
    mutationKey: [Keys.DELETE_REMINDER_MUT],
    mutationFn: deleteCustomer,
    onSuccess: onDeleteCustomerRes,
  });
